<script>
export default {
  name: 'Bus'
}
</script>
